import { render, staticRenderFns } from "./DmPlatformForm.vue?vue&type=template&id=11b479cc&scoped=true"
import script from "./DmPlatformForm.vue?vue&type=script&lang=js"
export * from "./DmPlatformForm.vue?vue&type=script&lang=js"
import style0 from "./DmPlatformForm.vue?vue&type=style&index=0&id=11b479cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b479cc",
  null
  
)

export default component.exports